var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Webber"},[_c('ol',[_c('li',[_vm._v("제한시간 안에 거미줄을 가장 많이 모으는 사람이 승리합니다")]),_vm._v(" "),_c('li',[_vm._v("거미줄을 모으는 도중 죽으면 탈락입니다")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c87f14c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mission/Webber.vue
// module id = 135
// module chunks = 1